import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=35fc2cde&scoped=true&"
import script from "./commentItem.vue?vue&type=script&lang=js&"
export * from "./commentItem.vue?vue&type=script&lang=js&"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=35fc2cde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc2cde",
  null
  
)

export default component.exports